import { Link } from "@tanstack/react-router";
import { Trans } from "@lingui/react/macro";

export default function NotFoundPage() {
  return (
    <main
      className="relative min-h-screen bg-white px-4 pb-12 pt-28 sm:px-6 sm:pt-32"
      data-testid="not-found-page"
    >
      <div className="mx-auto flex min-h-[calc(100vh-7rem)] max-w-5xl flex-col items-center justify-center gap-10 text-center">
        <div className="font-display text-[8rem] leading-none tracking-[-0.06em] text-[var(--color-ink)] sm:text-[10rem]">
          404
        </div>

        <div className="max-w-xl">
          <p className="text-xs font-semibold uppercase tracking-[0.34em] text-[var(--color-muted)]">
            <Trans>Página perdida</Trans>
          </p>
          <h1 className="mt-4 font-display text-5xl italic leading-[0.92] tracking-[-0.04em] text-[var(--color-ink)] sm:text-6xl">
            <Trans>Esta mesa no estaba en la lista.</Trans>
          </h1>
          <p className="mt-4 text-base leading-7 text-[var(--color-muted)] sm:text-lg">
            <Trans>Volvamos antes de que alguien reparta tu postre.</Trans>
          </p>
        </div>

        <Link
          className="app-btn-primary cursor-pointer"
          data-testid="not-found-home"
          to="/"
        >
          <Trans>Volver al inicio</Trans>
        </Link>
      </div>
    </main>
  );
}
